module.exports = __webpack_public_path__ + "img/KH.b51b06be.png";